import { commonFetch, fetch } from "./fetch";

// 获取字典列表
export function getDictionaryList(data) {
  return commonFetch(
    "/crm-mdm/v1/dictionary/dictdata/findByDictTypeCodeList",
    true,
    data
  );
}

export function createFeedback(data) {
  return commonFetch("/crm-sfa/v1/sfaSysFeedbackEntity/create", false, data);
}

export function getFeedbackList(data) {
  return commonFetch(
    "/crm-sfa/v1/sfaSysFeedbackEntity/findByConditions",
    true,
    data
  );
}

export function getFeedbackDetails(id) {
  return commonFetch(`/crm-sfa/v1/sfaSysFeedbackEntity/${id}`, true);
}

export function getOssKey() {
  return commonFetch(`/crm-sfa/v1/sfaSysFeedbackEntity/getAliOssAccess`, false);
}

export function getTianYanCha(data) {
  return commonFetch(
    "/crm-bridge/v1/push/tianyancha/tianYanCha_816",
    true,
    data
  );
}
export function addCusClue(qs) {
  return commonFetch(
    `/crm-sfa/v1/sfaClueInfoEntity/ignoreLoginCreateClue?${qs}`,
    true,
    {}
  );
}


//单点登录
export const loginUserCode = (params) => {
  return fetch({
    url: `/crm-bridge/v1/rbac/login`,
    method: "post",
    data: params,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const fileUploadVenus = (params) => {
  return fetch({
    url: `/crm-venus/v1/venus/files/fileUpload/default`,
    method: "post",
    data: params,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const commonApi = {
  getDictionaryList,
  createFeedback,
  getFeedbackList,
  getFeedbackDetails,
  getOssKey,
  loginUserCode,
  fileUploadVenus,
  getTianYanCha,
  addCusClue
};

export default commonApi;
